import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetMenu } from "../../store/api/menuApi";

function MenuList({ onEdit }) {
  const getMenu = useGetMenu();
  const {
    data: menuData,
    isLoading: isRoleLoading,
    error: roleError,
  } = useQuery({ queryKey: ["menu-data"], queryFn: getMenu });

  const data = menuData?.allMenu
    ?.map((e, index) => ({
      index: index + 1,
      name: e?.name,
      idNumber: e?.idNumber,
      category: e?.category?.map((c) => c.categoryId?.name || "N/A").join(", "),
      actionButton: (
        <>
          <button onClick={() => onEdit(e)} className="btn text-success mx-2">
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Name",
      accessor: "name",
    },
    {
      header: "id Number",
      accessor: "idNumber",
    },
    {
      header: "Category",
      accessor: "category",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} />
    </div>
  );
}

export default MenuList;
